/**
 * Nome legível de cada funcionalidade de IA do extrato (funcionalidade = rota ou fila; ação =
 * resto da rota ou tipo da tarefa). O que não estiver aqui aparece como veio do extrato.
 */
const FUNCIONALIDADES: Record<string, string> = {
  social: 'Redes sociais',
  content: 'Conteúdo',
  'ai-generation': 'Geração com IA',
  'image-studio': 'Image Studio',
  mcp: 'Assistente de IA',
  workflow: 'Automações',
  automation: 'Automações (criação)',
  'live-automation': 'Automação ao vivo',
  'traffic-manager': 'Gestor de tráfego',
  'traffic-managers': 'Gestor de tráfego',
  listening: 'Escuta social',
  'content-schedule': 'Rotina de conteúdo',
  blog: 'Blog',
  onboarding: 'Configuração inicial',
  'landing-pages': 'Landing pages',
  creatives: 'Criativos',
  campaigns: 'Campanhas',
  keywords: 'Palavras-chave',
  competitors: 'Concorrentes',
  'site-audit': 'Auditoria do site',
  interno: 'Sistema'
};

const ACOES: Record<string, string> = {
  'social.generate-caption': 'Legenda com IA',
  'image-studio.ai-edit': 'Edição de imagem com IA',
  'mcp.chat': 'Conversa com o assistente',
  'mcp.transcribe': 'Transcrição de áudio',
  'workflow.run': 'Execução de automação',
  'workflow.resume': 'Retomada de automação',
  'ai-generation.landing-page-chat': 'Landing page criada com IA',
  'ai-generation.landing-page-section': 'Seção de landing page',
  'ai-generation.landing-page-edit': 'Edição de landing page',
  'ai-generation.content-generate': 'Conteúdo gerado',
  'ai-generation.content-image': 'Imagem para conteúdo',
  'ai-generation.post-suggestions': 'Sugestões de posts',
  'ai-generation.post-regenerate': 'Post refeito',
  'ai-generation.hashtag-generate': 'Hashtags',
  'ai-generation.workflow-generate': 'Automação criada com IA',
  'ai-generation.full-site-audit': 'Auditoria completa do site',
  'ai-generation.keyword-suggestions': 'Sugestões de palavras-chave',
  'ai-generation.blog-generate': 'Artigo de blog',
  'ai-generation.blog-ai-write': 'Texto de blog',
  'ai-generation.blog-regenerate': 'Artigo refeito',
  'ai-generation.blog-seo-site': 'SEO do blog',
  'ai-generation.blog-seo-compare': 'Comparação de SEO',
  'ai-generation.carousel-generate': 'Carrossel',
  'ai-generation.image-studio-generate': 'Imagem no Image Studio',
  'ai-generation.listening-refresh': 'Atualização da escuta social',
  'ai-generation.website-analysis': 'Análise do site',
  'ai-generation.campaign-generate': 'Campanha criada com IA',
  'ai-generation.ads-exploration': 'Exploração de anúncios',
  'ai-generation.meta-ads-exploration': 'Exploração de anúncios da Meta'
};

export const rotuloFuncionalidade = (feature: string) => FUNCIONALIDADES[feature] || feature;

export const rotuloAcao = (feature: string, action: string | null) => {
  if (!action) return rotuloFuncionalidade(feature);
  return ACOES[`${feature}.${action}`] || `${rotuloFuncionalidade(feature)} · ${action}`;
};
